import { Controller, useFormContext } from 'react-hook-form';
import FormLabel from '../FormLabel';

interface CheckboxFieldProps {
  label: string;
  name: string;
  disabled?: boolean;
  testId?: string;
  isRequired?: boolean;
  validate?: (value: boolean) => boolean | string;
}
const CheckboxField = ({ label, name, disabled = false, testId, isRequired, validate }: CheckboxFieldProps) => {
  const { control, register } = useFormContext(); // retrieve all hook methods

  return (
    <FormLabel label={label}>
      <div className="w-full lg:w-1/2">
        <Controller
          name={name}
          control={control}
          rules={isRequired ? { required: 'This is required.', validate } : { validate }}
          render={({ field: { onChange, value }, fieldState: { error } }) => {
            return (
              <>
                <div className="relative flex items-center">
                  <input
                    ref={register(name).ref}
                    data-cy={testId}
                    disabled={disabled}
                    onChange={(event) => (onChange ? onChange(event.target.checked) : null)}
                    checked={value}
                    id="checked-checkbox"
                    type="checkbox"
                    className={`
                      appearance-none w-6 h-6 rounded 
                      border-2 border-gray-300 
                      bg-white
                      checked:bg-yellow-500 checked:border-yellow-500
                      hover:border-yellow-400
                      transition-colors duration-200 ease-in-out cursor-pointer
                      ${disabled ? 'opacity-50 cursor-not-allowed' : ''}
                    `}
                  />
                  {/* Custom checkmark */}
                  <span
                    className={`absolute left-[6px] top-[6px] w-3 h-3 transition-opacity duration-200 ease-in-out pointer-events-none ${value ? 'opacity-100' : 'opacity-0'}`}
                  >
                    <svg className="w-3 h-3 text-white" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M13.3332 4L5.99984 11.3333L2.6665 8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </span>
                </div>

                {error?.message && (
                  <p className="mt-2 text-sm text-error-600 dark:text-green-500">
                    <span className="font-medium">{error.message}</span>
                  </p>
                )}
              </>
            );
          }}
        />
      </div>
    </FormLabel>
  );
};

export { CheckboxField };
